var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5CA3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.4,86.7c-4.2-3.8-8.2-7.4-8.7-14.5c-0.8-10.9-6.1-29.1-33.2-29.1c-8.2,0-13.8,1.6-17,5 c-3.5,3.7-3.2,8.6-3,12.1c0.1,1.4,0.2,3-0.1,3.6c-0.6,1.5-2.8,3.6-4.9,5.6c-3.8,3.7-8,7.8-8,12.4c0,4,2.6,6.6,4.7,8.7 c2,2,2.8,3,2.6,4.2c-0.1,0.3-0.4,0.5-2.5,0.7c-3.6,0.5-9.7,1.3-12.1,11.2c-0.3,1.1,0.4,2.3,1.5,2.6c1.1,0.3,2.3-0.4,2.6-1.5 c1.8-7.1,5.2-7.6,8.6-8.1c2.2-0.3,5.3-0.7,6-4c0.8-3.6-1.6-6-3.7-8.1c-1.8-1.8-3.4-3.5-3.4-5.7c0-2.8,3.6-6.3,6.7-9.4 c2.5-2.5,4.9-4.8,5.8-7.1c0.6-1.5,0.5-3.3,0.4-5.4c-0.2-3.1-0.4-6.6,1.9-9c2.3-2.4,7-3.7,13.9-3.7c22.5,0,28.2,13.7,29,25.1 c0.6,8.8,5.7,13.3,10.1,17.3c5,4.5,8.9,8.1,6.3,16.8c-0.3,1.1,0.3,2.3,1.4,2.6c0.2,0.1,0.4,0.1,0.6,0.1c0.9,0,1.8-0.6,2-1.5 C119.3,96.5,113.5,91.3,108.4,86.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.7,105.1c-2.3-0.1-4.4-0.2-6.5-0.3c-0.6-1.5-1.6-4.6,0.4-7.8c5-7.9,3-11.2-0.3-15 c-0.4-0.5-0.9-1-1.3-1.6c-0.4-0.5-0.6-0.9-0.8-1.4c0,0,0-0.1,0-0.1c-0.2-0.9,0-1.8,0.3-3c0.9-3.4,1.2-6.7-4.7-10.1 c-9.2-5.4-9.5-11.4-9.5-11.7c0-1.2-1-2.1-2.1-2.1c-15,0-21.3,10-22.2,18.6c-0.3,2.6-0.1,5.4,0.6,8.1c-1.6,1.5-4.2,4.9-4.2,9.7 c0,2.7,1.5,5.1,3,7.3c2.5,3.8,3.6,6.1,0.9,9c-2.1,0.2-4.4,0.3-6.9,0.4c-1.2,0-2.1,1-2.1,2.2c0,1.1,1,2.1,2.1,2.1c0,0,0,0,0.1,0 c8.8-0.3,19.8-0.6,22.2-8.7c0.1-0.2,0.1-0.4,0.1-0.6v-4.1c1.4,0.5,2.8,1,4.3,1.3c0.4,0.1,0.7,0.1,1.1-0.1 c0.2-0.1,1.3-0.4,2.9-1.2v4c0,0.2,0,0.4,0.1,0.6c2.5,8.1,13.4,8.4,22.2,8.7c0,0,0,0,0.1,0c1.1,0,2.1-0.9,2.1-2.1 C99.8,106.1,98.9,105.2,97.7,105.1z M62.7,99.7c-0.8,2.2-2.9,3.4-5.9,4.2c1.3-4-1-7.7-2.7-10.4c-1.2-1.8-2.3-3.6-2.3-5 c0-2.2,0.8-3.9,1.6-5.1c1.9,4.1,5,7.9,9.3,10.5V99.7z M71.6,92.9c-11.7-2.7-17.1-13.2-16.2-22c0.7-6.8,5.3-14,16.2-14.7 c0.8,3,3.3,8.4,11.3,13.1c3.6,2.1,3.3,3.1,2.7,5.4c-0.3,1.3-0.8,2.9-0.4,4.8C83.2,87.9,73.9,92,71.6,92.9z M79.5,99.7v-6.1 c3.1-2,6.4-5,8.4-9.2c0.1,0.1,0.2,0.2,0.3,0.4c2.5,2.8,3.6,4.1-0.1,10c-2.2,3.5-2.1,7-1.5,9.5C83,103.4,80.4,102.1,79.5,99.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,73.9c-0.3-0.5-0.9-0.7-1.5-0.4c-2.4,1.4-4.8,0.1-4.9,0c-0.5-0.3-1.2-0.1-1.4,0.4 c-0.3,0.5-0.1,1.2,0.4,1.4c0.1,0.1,1.6,0.9,3.6,0.9c1,0,2.2-0.2,3.4-0.9C68,75,68.2,74.4,67.9,73.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,73.9c-0.3-0.5-0.9-0.7-1.5-0.4c-2.4,1.4-4.8,0.1-4.9,0c-0.5-0.3-1.2-0.1-1.4,0.4 c-0.3,0.5-0.1,1.2,0.4,1.4c0.1,0.1,1.6,0.9,3.6,0.9c1,0,2.2-0.2,3.4-0.9C83,75,83.2,74.4,82.9,73.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,83.8H69c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5.8c0.6,0,1.1-0.5,1.1-1.1 C75.8,84.3,75.3,83.8,74.7,83.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,69.7c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C109,74,107.4,72.1,107.4,69.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,33.6c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3C74.5,37.9,72.8,36,72.8,33.6z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,57c0.2,2.4-1.3,4.4-3.3,4.5c2-0.1,3.7,1.7,3.9,4c-0.2-2.4,1.3-4.4,3.3-4.5C41.9,61.2,40.2,59.4,40,57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 98.4,
    cy: 53.6,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 57.2,
    cy: 40.8,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,92.1c0,0.7-0.6,1.4-1.3,1.4c-0.7,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.4,1.4-1.4C33.4,90.7,34,91.3,34,92.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirgo);
export default __webpack_public_path__ + "static/media/Virgo.32f1c36431e5de3d5bf8865393694192.svg";
export { ForwardRef as ReactComponent };